var render, staticRenderFns
import script from "./AvatarSkeleton.vue?vue&type=script&lang=ts&"
export * from "./AvatarSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarSkeleton.vue?vue&type=style&index=0&id=2499a61c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports